module.exports = __webpack_public_path__ + "img/Tablet - 21.4e9ca58f.png";